export default __webpack_public_path__ + "static/media/team62.9e55f706.JPG";